module.exports = __webpack_public_path__ + "img/icon-sale-report2.7a922d56.png";